import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "../lib/utils";

export interface KeyFact {
  id: string;
  label: string;
  /** Rendered value — a string or a node (badge, status row). Falsy → em dash. */
  value?: ReactNode;
}

interface KeyFactsGridProps extends HTMLAttributes<HTMLDivElement> {
  facts: KeyFact[];
}

/**
 * Kennzahlen-Box (TES-1742, extrahiert nach @plasser/ui in TES-1999): die wichtigsten
 * Fakten eines Objekts prominent + KONSISTENT.
 *
 * Apple-Prinzip „wenig, aber das Richtige" — ein einheitliches Tile-Raster (label-caps-Label
 * + hervorgehobener Wert), das über alle Objekt-Typen (Prüfung/Mangel/Checkliste/MPP/Prüfobjekt)
 * gleich aussieht. Reuse der bestehenden Detail-Tile-Optik (`bg-surface-container-low`), damit
 * die Box sich nahtlos in das vorhandene Design einfügt. Leere Fakten-Liste → rendert nichts.
 * Labels/Werte sind fertige i18n-Strings des Aufrufers.
 */
export function KeyFactsGrid({ facts, className, ...rest }: KeyFactsGridProps) {
  if (facts.length === 0) return null;
  return (
    <div className={cn("grid grid-cols-2 gap-3 sm:grid-cols-3", className)} {...rest}>
      {facts.map((fact) => (
        <div key={fact.id} className="rounded-lg bg-surface-container-low p-4">
          <p className="text-label-caps text-muted-foreground mb-2">{fact.label}</p>
          <div className="break-words font-bold text-primary">{fact.value || "—"}</div>
        </div>
      ))}
    </div>
  );
}
